import * as React from 'react'
import './styles.scss'

export interface ButtonProps {
  labelPosition?: 'left' | 'right'
  icon?: any
  active?: boolean
  onClick?: () => void
  fullwidth?: boolean
  fill?: boolean
  outline?: boolean
  primary?: boolean
  classes?: string[]
  disabled?: boolean
  children?: React.ReactNode
}

const defaultProps: Partial<ButtonProps> = {
  labelPosition: 'left',
}

export const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const label = <div className='button__label'>{props.children}</div>

  const icon = props.icon && (
    <div className={`button__icon ${props.labelPosition === 'right' ? 'mr-2' : 'ml-2'}`}>
      {props.icon}
    </div>
  )

  let classes = ['button']

  if (props.fullwidth) {
    classes.push('full-width')
  }
  if (props.active) {
    classes.push('active')
  }
  if (props.fill) {
    classes.push('fill')
  }
  if (props.outline) {
    classes.push('outline')
  }
  if (props.primary) {
    classes.push('primary')
  }

  if (props.classes) {
    classes = [...classes, ...props.classes]
  }

  return (
    <button onClick={props.onClick} className={classes.join(' ')} disabled={props.disabled}>
      {props.labelPosition === 'right' ? (
        <div className='button__inner'>
          {icon}
          {label}
        </div>
      ) : (
        <div className='button__inner'>
          {label}
          {icon}
        </div>
      )}
    </button>
  )
}

Button.defaultProps = defaultProps
